import * as React from 'react';
import { cn } from '@/lib/utils';

export interface PillButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}

export const PillButton = React.forwardRef<HTMLButtonElement, PillButtonProps>(
  ({ className, selected = false, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        'inline-flex h-7 items-center rounded-full border px-2.5 text-xs transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        selected
          ? 'border-primary bg-primary text-primary-foreground hover:bg-primary/90'
          : 'bg-background text-muted-foreground hover:bg-accent hover:text-accent-foreground',
        className,
      )}
      {...props}
    />
  ),
);

PillButton.displayName = 'PillButton';

export const PillGroup: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ className, ...props }) => (
  <div
    className={cn(
      'inline-flex max-w-full min-w-0 overflow-hidden rounded-full border bg-background p-0.5',
      className,
    )}
    {...props}
  />
);

